module.exports = __webpack_public_path__ + "img/download_qrcode.2623dcb9.png";